import React from 'react';
import styled from 'styled-components';
import VehicleDoor from './vehicle-door';
import VehicleWheel from './vehicle-wheel';
import VehicleBody from './vehicle-body';
import VehicleBumper from './vehicle-bumper';
import VehicleFrontFender from './vehicle-front-fender';
import VehicleQuarterPanel from './vehicle-quarter-panel';
import { VehiclePart, VehicleSide, CarItem } from '../../enums';

export type VehicleState = { [item in CarItem]: string };

export interface VehicleModelProps {
  className?: string;
  clickHandler?: (vehiclePart: string) => void;
  vehicleState?: VehicleState;
}

interface VehicleImgFilter {
  name: string;
  cssRule: string;
}

interface Props extends VehicleModelProps {
  vehicleImgFilters?: VehicleImgFilter[];
}

class CarModel extends React.Component<Props, any> {
  static defaultProps = {
    vehicleState: {} as VehicleState,
  };

  render() {
    const { className, vehicleImgFilters, ...other } = this.props;

    return (
      <div className={className}>
        <div className="flex-col align-start">
          <VehicleFrontFender side={VehicleSide.Left} {...other} />
          <VehicleDoor
            part={VehiclePart.Front}
            side={VehicleSide.Left}
            {...other}
          />
          <VehicleDoor
            part={VehiclePart.Rear}
            side={VehicleSide.Left}
            {...other}
          />
          <VehicleQuarterPanel side={VehicleSide.Left} {...other} />
        </div>
        <div className="flex-col justify-around">
          <VehicleWheel
            part={VehiclePart.Front}
            side={VehicleSide.Left}
            {...other}
          />
          <VehicleWheel
            part={VehiclePart.Rear}
            side={VehicleSide.Left}
            {...other}
          />
        </div>
        <div className="flex-col">
          <VehicleBumper part={VehiclePart.Front} {...other} />
          <VehicleBody className="flex-col" {...other} />
          <VehicleBumper part={VehiclePart.Rear} {...other} />
        </div>
        <div className="flex-col justify-around">
          <VehicleWheel
            part={VehiclePart.Front}
            side={VehicleSide.Right}
            {...other}
          />
          <VehicleWheel
            part={VehiclePart.Rear}
            side={VehicleSide.Right}
            {...other}
          />
        </div>
        <div className="flex-col align-end">
          <VehicleFrontFender side={VehicleSide.Right} {...other} />
          <VehicleDoor
            part={VehiclePart.Front}
            side={VehicleSide.Right}
            {...other}
          />
          <VehicleDoor
            part={VehiclePart.Rear}
            side={VehicleSide.Right}
            {...other}
          />
          <VehicleQuarterPanel side={VehicleSide.Right} {...other} />
        </div>
      </div>
    );
  }
}

const createCssRule = (selector: string, rule: string): string =>
  `&.${selector} { ${rule} }`;

const StyledCarModel = styled(CarModel)`
  display: inline-flex;
  padding: 1.5em;

  .flex-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .justify-around {
    justify-content: space-around;
  }

  .align-start {
    align-items: flex-start;
  }

  .align-end {
    align-items: flex-end;
  }

  .vehicle-state-img {
    ${({ vehicleImgFilters }) =>
      vehicleImgFilters &&
      vehicleImgFilters.map(({ name, cssRule }) =>
        createCssRule(name, cssRule),
      )}
  }
`;

export default StyledCarModel;
